<div class="main-container">
    <div class="pseudo-container">
        <h1>{{ "Choose your display name" | translate}}</h1>
        <label for="pseudo">{{'Your first name or nickname' | translate}}</label>
        <input type="text" name="pseudo" class="pseudo" placeholder="{{'Your first name or nickname' | translate}}">
        <div class="error-message-container" *ngIf="pseudoValueTooLong">
            <img src="../../../../assets/icons/museum/warning-museum-lilia.svg">
            <span class="error-message">
                {{ 'pseudoValueTooLong' | translate}}
            </span>
            <img src="../../../../assets/icons/museum/lilia-museum-cross.svg" (click)="closeErrorMessage()">
        </div>
        <div class="error-message-container" *ngIf="pseudoValueIsMandatory">
            <img src="../../../../assets/icons/museum/warning-museum-lilia.svg">
            <span class="error-message">
                {{ 'pseudoValueIsMandatory' | translate}}
            </span>
            <img src="../../../../assets/icons/museum/lilia-museum-cross.svg" (click)="closeErrorMessage()">
        </div>
        <button (click)="handlePseudoInput()">{{'choose nickname' | translate}}</button>
    </div>
</div>